import { createBox } from '@famly/mf_layout_box';
export const ModalForm = createBox({ component: 'form', display: 'flex', flexDirection: 'column', flex: 1 });
